export const logo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="374.879"
    height="94.654"
    viewBox="0 0 374.879 94.654"
  >
    <g
      id="Layer_1_00000180349307974994940450000007026122523903870362_"
      transform="translate(-1.6 -4.4)"
    >
      <g id="Group_143" data-name="Group 143" transform="translate(1.6 4.4)">
        <g id="Group_142" data-name="Group 142" transform="translate(166.318)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M710.875,18.081V7.424A3.02,3.02,0,0,0,707.851,4.4H690.324A3.02,3.02,0,0,0,687.3,7.424V18.081Z"
            transform="translate(-652.304 -4.4)"
            fill="#00ff82"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M591.675,18.081V7.424A3.02,3.02,0,0,0,588.651,4.4H571.124A3.02,3.02,0,0,0,568.1,7.424v7.663a3.02,3.02,0,0,0,3.024,3.024l20.551-.029Z"
            transform="translate(-568.1 -4.4)"
            fill="#00ff82"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M725.137,50.929h-7.663a3.02,3.02,0,0,0-3.024,3.024v43.3H693.107V53.924a3.02,3.02,0,0,0-3.024-3.024H679.425V97.228H658.081v-46.3H644.4v43.3a3.02,3.02,0,0,0,3.024,3.024h9.542v10.657a3.02,3.02,0,0,0,3.024,3.024h17.527a3.02,3.02,0,0,0,3.024-3.024V97.258h11.45v10.657a3.02,3.02,0,0,0,3.024,3.024h17.527a3.02,3.02,0,0,0,3.024-3.024V97.258h9.542a3.02,3.02,0,0,0,3.024-3.024V53.924a2.97,2.97,0,0,0-2.995-2.995Z"
            transform="translate(-621.999 -37.248)"
            fill="#fff"
          />
        </g>
        <path
          id="Path_4"
          data-name="Path 4"
          d="M981.38,139.237h-2.261q-7.486,0-11.538-3.963c-2.7-2.642-4.081-6.459-4.081-11.45v-17.41c0-4.991,1.351-8.808,4.081-11.45Q971.632,91,979.119,91h21.843a1.812,1.812,0,0,1,2.084,2v44.27a1.812,1.812,0,0,1-2.084,2h-7.956a1.773,1.773,0,0,1-2-2v-3.112h-.382a7.172,7.172,0,0,1-3.875,3.934,13.824,13.824,0,0,1-5.369,1.145Zm9.63-17.586v-19.2c0-.7-.382-1.028-1.145-1.028h-8.9c-2.026,0-3.435.44-4.257,1.292s-1.233,2.29-1.233,4.316V123.3a6.1,6.1,0,0,0,1.233,4.257c.822.881,2.231,1.321,4.257,1.321h3.494c2.583,0,4.316-.7,5.2-2.084a9.311,9.311,0,0,0,1.35-5.139Z"
          transform="translate(-681.097 -65.575)"
          fill="#fff"
        />
        <path
          id="Path_5"
          data-name="Path 5"
          d="M1161.64,110.556h-8.04a1.772,1.772,0,0,1-2-2V52.4a1.772,1.772,0,0,1,2-2h8.045a1.773,1.773,0,0,1,2,2v56.193a1.764,1.764,0,0,1-2.005,1.963Z"
          transform="translate(-813.973 -36.895)"
          fill="#fff"
        />
        <path
          id="Path_6"
          data-name="Path 6"
          d="M1247.44,110.556h-8.04a1.773,1.773,0,0,1-2-2V52.4a1.773,1.773,0,0,1,2-2h8.045a1.772,1.772,0,0,1,2,2v56.193a1.752,1.752,0,0,1-2.005,1.963Z"
          transform="translate(-874.583 -36.895)"
          fill="#fff"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M13.7,111.743H3.6a2,2,0,0,1-2-2V52.5a2,2,0,0,1,2-2H26.849c4.962,0,8.808,1.321,11.538,3.993s4.081,6.518,4.081,11.538v9.131c0,5.02-1.38,8.866-4.081,11.538-2.73,2.672-6.576,3.993-11.538,3.993H14.841q-1.145,0-1.145,1.057Zm1.057-31.649h10.1c2.026,0,3.464-.44,4.286-1.292s1.233-2.261,1.233-4.228V66.559c0-2.026-.411-3.464-1.233-4.345-.822-.851-2.261-1.292-4.286-1.292h-10.1A1.053,1.053,0,0,0,13.7,61.979V79.037a1.053,1.053,0,0,0,1.053,1.057Z"
          transform="translate(-1.6 -36.966)"
          fill="#fff"
        />
        <path
          id="Path_8"
          data-name="Path 8"
          d="M188.4,111.743h-8.1a2,2,0,0,1-2-2V52.5a2,2,0,0,1,2-2h8.1a2,2,0,0,1,2,2v57.25A2.018,2.018,0,0,1,188.4,111.743Z"
          transform="translate(-126.423 -36.966)"
          fill="#fff"
        />
        <path
          id="Path_9"
          data-name="Path 9"
          d="M281.9,142.189h-2.29c-5.02,0-8.9-1.321-11.626-3.993s-4.081-6.518-4.081-11.538V109.131c0-5.02,1.351-8.866,4.081-11.538S274.59,93.6,279.61,93.6H301.6c1.409,0,2.084.675,2.084,2v44.567a1.812,1.812,0,0,1-2.084,2h-8.015a2,2,0,0,1-2-2v-3.141h-.352a7.092,7.092,0,0,1-3.9,3.963A13.574,13.574,0,0,1,281.9,142.189Zm9.718-17.733V105.109q0-1.057-1.145-1.057h-8.954c-2.026,0-3.464.44-4.286,1.292S276,107.634,276,109.689v16.382a6.179,6.179,0,0,0,1.233,4.286c.822.881,2.261,1.321,4.286,1.321h3.523c2.613,0,4.345-.7,5.226-2.084a9.176,9.176,0,0,0,1.347-5.138Z"
          transform="translate(-186.892 -67.412)"
          fill="#fff"
        />
        <path
          id="Path_10"
          data-name="Path 10"
          d="M466.27,93.6h-8.015a2.2,2.2,0,0,0-2.378,2l-8.1,35.143h-.382L439.2,95.6a2.29,2.29,0,0,0-2.378-2h-8.485c-1.321,0-1.82.675-1.439,2l11.156,42.013a3.213,3.213,0,0,0,.822,1.468,2.153,2.153,0,0,0,1.585.528h5.05l-5.285,20.757a1.366,1.366,0,0,0,1.321,1.7h8.69a1.35,1.35,0,0,0,1.321-1.028L468.2,95.685C468.5,94.3,467.856,93.6,466.27,93.6Z"
          transform="translate(-301.949 -67.412)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
